<div>
  <header>
    <div class="poe-header" [innerHTML]="poeHeader"></div>
  </header>
  <aur-page  [hideHeader]="true">
    <aur-card>
      <div class="center" *ngIf="status; then successBlock else failBlock"></div>
      <ng-template #successBlock>
        <div class="center">
          <img class="okcheck" src="assets/layout/images/confirmation.png" />
          <br />
          <p class="confirmation-text">Confirmation</p>
          <div class="mobile-view-only">
            <br />
            <hr>
          </div>
          <p class="confirm-msg-text">Thank you for your payment.</p>
        </div>
      </ng-template>
      <ng-template #failBlock>
        <div id="u1153" class="ax_default materialicons">
          <div id="u1153_text" class="text ">
            <p><span>error</span></p>
          </div>
        </div>
        <div id="u1151" class="ax_default heading_3">
          <div id="u1151_text" class="text ">
            <p><span>Transaction has failed</span></p>
          </div>
        </div>
        <div id="u1152" class="ax_default">
          <div id="u1152_text" class="text ">
            <p><span style="color:#1B222C;" class="spaceAlignment">We apologize for this inconvenience. </span></p>
            <p><span style="color:#1B222C;">If you need assistance, Please </span><span style="color:#169BD5;">
                <a [routerLink]="" (click)="largeDialogVisible = true">Contact us</a></span>.</p>
          </div>
        </div>
      </ng-template>
      <div class="p-grid">
        <div class="Payment-method-container mobile-view-only p-col-6 col" style="text-align: right;">
          <div class="payment-info">
            <a href="javascript:void(0)" (click)="returntohome()" style="color: #1376a4 !important;cursor: pointer;"
              *ngIf="gobackButton">
              <label class="homeInfo-label">Return to Beginning</label>
            </a>
          </div>
          <div class="payment-info">
            <label class="dateInfo-label">
              <a href="javascript:void(0)" (click)="downloadPDF('download')">
                <svg aria-hidden="true" style="width: 13px;" focusable="false" data-prefix="fad" data-icon="download"
                  role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                  class="svg-inline--fa fa-download fa-w-16 fa-fw fa-2x">
                  <g class="fa-group">
                    <path fill="currentColor"
                      d="M320 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3a19.37 19.37 0 0 1-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24a23.94 23.94 0 0 1 24-24h80a23.94 23.94 0 0 1 24 24z"
                      class="fa-secondary"></path>
                    <path fill="currentColor"
                      d="M488 352H341.3l-49 49a51.24 51.24 0 0 1-72.6 0l-49-49H24a23.94 23.94 0 0 0-24 24v112a23.94 23.94 0 0 0 24 24h464a23.94 23.94 0 0 0 24-24V376a23.94 23.94 0 0 0-24-24zm-120 96a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm64 0a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
                      class="fa-primary"></path>
                  </g>
                </svg>
                Download</a>
            </label>
          </div>
        </div>

        <div class="Payment-method-container p-col-6 col">
          <div class="payment-info">
            <label class="dateInfo-label">Confirmation Number:</label>
            <p class="dateInfo-value">{{confirmationNumber}}</p>
          </div>
          <div class="payment-info">
            <label class="dateInfo-label">Confirmation Date:</label>
            <p class="dateInfo-value">{{ConfirmationDate}}</p>
          </div>
          <div class="payment-info mobile-view-only">
            <label class="dateInfo-label">Payment Date:</label>
            <p class="dateInfo-value">{{this.paymentDate}}</p>
          </div>
        </div>
        <div class="Payment-method-container p-col-6 col" style="justify-content:flex-end">
          <div class="payment-info  web-view-only " *ngIf="gobackButton">
            <a href="javascript:void(0)" (click)="returntohome()" style="color: #1376a4 !important;cursor: pointer;">
              <label class="homeInfo-label">Return to Beginning</label>
            </a>
          </div>
          <div class="payment-info  web-view-only ">
            <label class="dateInfo-label">
              <a href="javascript:void(0)" (click)="downloadPDF('download')" style="color: #1376a4 !important;">
                <svg aria-hidden="true" style="width: 13px;" focusable="false" data-prefix="fad" data-icon="download"
                  role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                  class="svg-inline--fa fa-download fa-w-16 fa-fw fa-2x">
                  <g class="fa-group">
                    <path fill="currentColor"
                      d="M320 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3a19.37 19.37 0 0 1-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24a23.94 23.94 0 0 1 24-24h80a23.94 23.94 0 0 1 24 24z"
                      class="fa-secondary"></path>
                    <path fill="currentColor"
                      d="M488 352H341.3l-49 49a51.24 51.24 0 0 1-72.6 0l-49-49H24a23.94 23.94 0 0 0-24 24v112a23.94 23.94 0 0 0 24 24h464a23.94 23.94 0 0 0 24-24V376a23.94 23.94 0 0 0-24-24zm-120 96a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm64 0a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
                      class="fa-primary"></path>
                  </g>
                </svg>
                Download
              </a>
            </label>
          </div>
        </div>
      </div>
      <div style="clear:both"></div>
      <div class="web-view-only">
        <hr>
      </div>
      <div class="Payment-method-container">
        <div class="payment-info">
          <label class="info-label">
            Account:
          </label>
          <p class="info-value">
            {{this.accountName}}
          </p>
          <p class="info-value">
            {{this.accountNumber}}
          </p>
        </div>
        <div class="payment-info web-view-only">
          <label class="info-label">
            Payment Date:
          </label>
          <p class="info-value">
            {{this.paymentDate}}
          </p>
        </div>
        <div class="payment-info">
          <label class="info-label">
            Payment Method:
          </label>
          <p class="info-value">
            {{this.paymentMethod}}
          </p>
        </div>
      </div>
      <div>
        <p-table #table [autoLayout]="true" [columns]="cols" [value]="documents" dataKey="documentId"
          [responsive]="true" styleClass="document-ptable">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th><span>Document</span> </th>
              <th><span>PO Number</span></th>
              <th><span>Due Date</span> </th>
              <th> <span>Amount</span></th>
              <th><span>Paid Online</span> </th>
              <th><span>Pay Amount</span> </th>
              <th *ngIf="spReason"> <span>Reason</span> </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-col let-columns="columns" let-rowIndex="rowIndex">
            <tr>
              <td class="test_documt">
                <div class="mobile-view-only text-align-left">Document</div>
                <div class="mobile-device-class common-class">
                  <span class="mobile-view-only">{{col.documentTypeName}}</span><br>
                  <span class="td-span-size"> {{col.invoiceNumber}} </span>
                </div>
              </td>
              <td>
                <div class="mobile-view-only text-align-left">PO Number</div>
                <div class="common-class">
                  <span class="td-span-size"> {{col.poNumber}}</span>
                </div>
              </td>
              <td>
                <div class="mobile-view-only text-align-left">Due Date</div>
                <div class="common-class mobile-device-class">
                  <span class="td-span-size"> {{checkDateFormate(col.dueDate)}} </span>
                </div>
              </td>
              <td class="mv-border-bottom">
                <div class="mobile-view-only text-align-left">Amount</div>
                <div class="common-class">
                  <span class="td-span-size"> {{col.totalDue}}</span>
                </div>
              </td>
              <td>
                <div class="mobile-view-only text-align-left">Paid Online</div>
                <div class="common-class">
                  <span class="td-span-size"> {{col.paidOnline}}</span>
                </div>
              </td>
              <td>
                <div class="mobile-view-only text-align-left">Pay Amount</div>
                <div class="common-class">
                  <span class="td-span-size"> {{col.payAmount}}</span>
                </div>
              </td>
              <td class="mobile-view-only">
                <div class="text-align-left">Document Date</div>
                <div class="common-class">
                  <span class="td-span-size"> {{checkDateFormate(col.billDate)}}</span>
                </div>
              </td>
              <td *ngIf="col.showPay">
                <div class="mobile-view-only text-align-left">Reason</div>
                <span *ngIf="col.shortPayreason != 'Others'" class="td-span-size shortPay-label">
                  {{col.shortPayreason}}</span>
                <span *ngIf="col.shortPayreason === 'Others'" class="td-span-size shortPay-label"
                  tooltip="{{col.shortPayText}}" placement="bottom" delay="500">
                  {{col.checkDetails}}
                </span>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-align-center">
                No records found
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="p-grid">
        <div class="p-col-6 col-acc-padding-right">
          <div class="p-col-12 col-acc-padding-left">
            <div class="payments-summary-container">
              <div class="payments-summary">
                <div class="payments-info">
                  <label class="payments-label">Total Documents:</label>
                  <p class="payments-value">{{totalDocuments}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-col-6 col-acc-padding-left">
          <div class="p-col-12 col-acc-padding-left">
            <div class="payments-summary-container">
              <div class="payments-summary">
                <div *ngIf="isConvenienceLableShow">
                  <div class="payments-info">
                    <label class="payments-label">Subtotal:</label>
                    <p class="payments-value">{{ formatNumber(subtotal) }}</p>
                  </div>
                  <div class="payments-info">
                    <label class="payments-label">
                      <div [innerHtml]="_customConvenienceFeeLabel"></div>
                    </label>
                    <p class="payments-value">{{ formatNumber(convenience) }}</p>
                  </div>
                  <div class="payments-info" *ngIf="isCustomConvenienceLableShow">
                    <aur-notice severity="warning">
                      <div [innerHtml]="_customConvenienceCC"></div>
                    </aur-notice>
                  </div>
                </div>
                <div>
                  <hr>
                </div>
                <div class="payments-info" id="confirmcurrencyType{{currencyVal}}">
                  <label class="payments-label">{{currencyType}}Total Amount:</label>
                  <p class="payments-value">{{ formatNumber(totalAcount) }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p-dialog header="Have Questions? Contact Us" [(visible)]="largeDialogVisible" [modal]="true">
        <P [innerHTML]="poeContact"></P>
      </p-dialog>
    </aur-card>
  </aur-page>
  <footer>
    <div class="poe-footer" [innerHTML]="poeFooter"></div>
    <div style="text-align: center;"><a [routerLink]="" (click)="largeDialogVisible = true">Contact Us</a>
    </div>
  </footer>
</div>